import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Eye, EyeOff, Link2 } from 'lucide-react';

const visibilityOptions = [
  { value: 'public', label: 'Public', icon: Eye, description: 'Visible to everyone' },
  { value: 'unlisted', label: 'Unlisted', icon: Link2, description: 'Only accessible via direct link' },
  { value: 'private', label: 'Private', icon: EyeOff, description: 'Only visible to you' },
];

export const VisibilitySelector = ({ value = 'public', onChange }) => {
  return (
    <div className="space-y-2">
      <Label>Visibility</Label>
      <div className="flex gap-2 flex-wrap">
        {visibilityOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`
                flex items-center gap-2 px-3 py-2 rounded-lg border transition-all
                ${isSelected 
                  ? 'bg-primary text-primary-foreground border-primary' 
                  : 'bg-secondary/50 hover:bg-secondary border-border text-muted-foreground hover:text-foreground'
                }
              `}
              data-testid={`visibility-${option.value}`}
            >
              <Icon className="w-4 h-4" />
              <span className="text-sm font-medium">{option.label}</span>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">
        {visibilityOptions.find(o => o.value === value)?.description}
      </p>
    </div>
  );
};

export const VisibilityBadge = ({ visibility }) => {
  const option = visibilityOptions.find(o => o.value === visibility) || visibilityOptions[0];
  const Icon = option.icon;
  
  const variants = {
    public: 'bg-green-500/10 text-green-500 border-green-500/20',
    unlisted: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    private: 'bg-red-500/10 text-red-500 border-red-500/20',
  };

  return (
    <Badge variant="outline" className={`text-xs ${variants[visibility] || ''}`}>
      <Icon className="w-3 h-3 mr-1" />
      {option.label}
    </Badge>
  );
};

export default VisibilitySelector;
